var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17V15.3541C19 14.5363 18.5021 13.8008 17.7428 13.4971L15.7086 12.6835C14.7429 12.2971 13.6422 12.7156 13.177 13.646L13 14C13 14 10.5 13.5 8.5 11.5C6.5 9.5 6 7 6 7L6.35402 6.82299C7.28438 6.35781 7.70285 5.25714 7.31654 4.29136L6.50289 2.25722C6.19916 1.4979 5.46374 1 4.64593 1H3C1.89543 1 1 1.89543 1 3C1 11.8366 8.16344 19 17 19C18.1046 19 19 18.1046 19 17Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.f35326e97a6549d082c8fad468982699.svg";
export { ForwardRef as ReactComponent };